import { createContext, useContext } from 'react';

export const CONTACT_EMAIL = 'kristian02@live.de';

export const translations = {
  de: {
    eyebrow: 'BOCHUM',
    heroDescription: 'Wirtschaftsinformatik-Student',
    heroDescriptionTail: ' mit Blick für neue Welten.',
    studyLabel: ['STUDENT', 'WIRTSCHAFTSINFORMATIK'],
    aboutTitle: 'Über mich',
    aboutText: [
      'Ich studiere momentan Wirtschaftsinformatik in Gelsenkirchen und bin auf dem Weg zum Abschluss. Praxis habe ich schon gesammelt und dabei gelernt: IT ist nicht nur Technik, sondern löst echte Probleme im Unternehmen.',
      'Genau dafür bringe ich den Blick fürs Ganze mit: die Ziele von Unternehmen, die Bedürfnisse der Kunden und die Anforderungen an die IT.',
    ],
    workLabel: 'WERKSTUDENT · WIRTSCHAFTSINFORMATIK',
    workTitle: ['Ich suche ', 'euch!'],
    workText: 'Nach einem Jahr in der IT der Stadt Gelsenkirchen suche ich einen neuen Ort, an dem ich weitere Erfahrungen sammeln und Teil eines Teams werden kann.',
    teamNote: 'Noch kein Team gefunden',
    portraitAlt: 'Portrait von Kristian Obolewicz',
    portraitStage: 'Kristian',
    mailTitle: 'Schreib mir',
    mailHint: 'Ich freu mich auf deine Nachricht',
    navAbout: 'Über mich',
    navWork: 'Werkstudent',
    navBack: 'Zurück',
  },
  en: {
    eyebrow: 'BOCHUM',
    heroDescription: 'Business informatics student',
    heroDescriptionTail: ' with an eye for new worlds.',
    studyLabel: ['STUDENT', 'BUSINESS INFORMATICS'],
    aboutTitle: 'About me',
    aboutText: [
      "I'm currently studying business informatics in Gelsenkirchen and I'm on my way to graduating. I've already gained hands-on experience and learned one thing along the way: IT isn't just technology, it solves real problems for businesses.",
      "That's exactly where I bring the big picture: the goals of businesses, the needs of customers and the requirements for IT.",
    ],
    workLabel: 'WORKING STUDENT · BUSINESS INFORMATICS',
    workTitle: ["I'm looking for ", 'you!'],
    workText: "After a year in the IT department of the City of Gelsenkirchen, I'm looking for a new place where I can gain more experience and become part of a team.",
    teamNote: 'No team found yet',
    portraitAlt: 'Portrait of Kristian Obolewicz',
    portraitStage: 'Kristian',
    mailTitle: 'Text me',
    mailHint: 'Happy to hear from you',
    navAbout: 'About me',
    navWork: 'Working student',
    navBack: 'Back',
  },
};

export const LanguageContext = createContext('de');

export const useT = () => translations[useContext(LanguageContext)];
